module.exports = __webpack_public_path__ + "img/visore_fiori_2025.63542805.png";